<template>
  <div class="cert-color-box d-flex flex-row" :class="`cert-${color}`">
    <micon v-if="icon!=null" :icon="icon"/>
    <div class="cert-text" >{{ title }}</div>
  </div>
</template>

<script>
export default {
  name: "CertColorBox",
  props: {
    title: String,
    icon: String,
    color: String,
  },
}
</script>
